import { useEffect } from 'react';

import { store } from '../wrappers/WithStore';

export const useOnSync = (callback: Function) => {
    useEffect(() => {
        const subscription = onEverySyncEnd(callback);
        return () => {
            subscription.end();
        };
    }, [callback]);
};

export function onEverySyncEnd(callback: Function) {
    let lastSyncInProgress = store.getState().sync.inProgress;
    const unsubscribe = store.subscribe(() => {
        const syncInProgress = store.getState().sync.inProgress;
        const shouldExecute = !syncInProgress && lastSyncInProgress;
        lastSyncInProgress = syncInProgress;
        if (shouldExecute) {
            callback();
        }
    });
    return {
        end: () => unsubscribe(),
    };
}

export const useOnSupplementalDataSync = (callback: Function) => {
    useEffect(() => {
        const subscription = onEverySupplementalDataSyncEnd(callback);
        return () => {
            subscription.end();
        };
    }, [callback]);
};

export function onEverySupplementalDataSyncEnd(callback: Function) {
    let lastSyncInProgress = store.getState().supplementalDataSync.inProgress;
    const unsubscribe = store.subscribe(() => {
        const syncInProgress = store.getState().supplementalDataSync.inProgress;
        const shouldExecute = !syncInProgress && lastSyncInProgress;
        lastSyncInProgress = syncInProgress;
        if (shouldExecute) {
            callback();
        }
    });
    return {
        end: () => unsubscribe(),
    };
}
